import React from 'react';
import { Caption } from '@randajan/jet-react/dom/caption';
import { Img } from '@randajan/jet-react/dom/img';
import logo from '../../../images/logo/logo_whiteLine.png';


import "./Welcome.scss";

export const Welcome = (props)=>{
    const { content } = props;
    const { brand, motto, homepage } = content;
    const { headline, lead } = homepage.hero;
    
    return (
        <article className="Welcome">
            <Img src={logo} id="logo"></Img>
            <span className="Welcome__brand">{brand}</span>
            <Caption>{headline || motto}</Caption>
            <p id='subHeading'>{lead}</p>
        </article>
    )
}

